import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { FormInput_textarea } from 'components/form/formInput/FormInput_textarea';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import usePromiseInstance_authorization from 'dataflow/billingPortal/actions/config';
import { setCOMRequestStatus } from 'dataflow/billingPortal/slices/companyInfo.slices';
import { cloneObject, func_serviceHandling, func_validation, isArrayNotEmpty, isBooleanFalseNotNullUndefined, isObjectNotEmpty, isStringTrimNotEmpty } from 'functions';
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

export function useTableActions(props) {
    const dispatch = useDispatch();
    const updatingSingleRowPos = useRef();
    const isRejecting = useRef();

    const totalPendingRequests = useRef(0);
    const [selectedCOMs, setSelectedCOMs] = useState();
    const [selectedCOMReasons, setSelectedCOMReasons] = useState({});
    const [isUpdatingMultiple, setIsUpdatingMultiple] = useState();

    const [singleCOMDetail, setSingleCOMDetail] = useState({});
    const [singleCOMReason, setSingleCOMReason] = useState("");

    const [isSingleUpdate, setIsSingleUpdate] = useState();
    const [isModalVisible, setIsModalVisible] = useState();
    const [isUpdateSuccessful, setIsUpdateSuccessful] = useState();
    const [isRerenderingRequired, setIsRerenderingRequired] = useState();
    
    const request = usePromiseInstance_authorization();

    function updateMultipleCOMs() {
        if (isArrayNotEmpty(selectedCOMs)) {
            setIsUpdatingMultiple(true);
            setIsUpdateSuccessful(false);
            dispatch(setCOMRequestStatus(undefined));
            totalPendingRequests.current = selectedCOMs.length;
            let isRejected = isRejecting.current;

            selectedCOMs.map((comDetails, idx) => {
                let paramObj = {
                    id: comDetails?.Id,
                    responseReason: selectedCOMReasons?.[idx],
                }
        
                let url = func_serviceHandling.createUrlWithParams(isRejected? "/ComInfo/RejectComRequest/":"/ComInfo/AcceptComRequest/", paramObj);

                request(null, (axios) => {
                    axios.put(url)
                        .then((response) => {
                            Toaster({
                                type: "success",
                                msg: "Successfully " + (isRejected? "rejected": "accepted") + " COM(s)"
                            });

                            setSelectedCOMs([]);
                            setIsUpdateSuccessful(totalPendingRequests.current == 1);
                            dispatch(setCOMRequestStatus(totalPendingRequests.current == 1));
                        })
                        .catch((response) => {
                            Toaster({
                                type: "error",
                                msg: response?.error?.response?.data?.exceptionMessage,
                                timer: 7000
                            });
                        })
                        .then(() => {
                            totalPendingRequests.current = totalPendingRequests.current - 1;
                            if (totalPendingRequests.current == 0) setIsUpdatingMultiple(false);
                        })
                })
            })
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 row"
            })
        }
    }

    function updateSingleCOM() {
        if (isObjectNotEmpty(singleCOMDetail)) {
            let rowIndex = singleCOMDetail?.index;
            updatingSingleRowPos.current = rowIndex;
            setIsUpdateSuccessful(false);
            setIsRerenderingRequired("");
            dispatch(setCOMRequestStatus(undefined));
            let isRejected = isRejecting.current;

            let paramObj = {
                id: singleCOMDetail?.original?.Id,
                responseReason: singleCOMReason,
            }
    
            let url = func_serviceHandling.createUrlWithParams(isRejected? "/ComInfo/RejectComRequest/":"/ComInfo/AcceptComRequest/", paramObj);

            request(null, (axios) => {
                axios.put(url)
                    .then((response) => {
                        Toaster({
                            type: "success",
                            msg: "Successfully " + (isRejected? "rejected": "accepted") + " COM"
                        });
                        
                        setIsUpdateSuccessful(true);
                        dispatch(setCOMRequestStatus(true));
                    })
                    .catch((response) => {
                        Toaster({
                            type: "error",
                            msg: response?.error?.response?.data?.exceptionMessage,
                            timer: 7000
                        });
                    })
                    .then(() => {
                        updatingSingleRowPos.current = undefined;
                        setIsRerenderingRequired(Math.random());
                    })
            })
        }
        else {
            Toaster({
                type: "info",
                msg: "Table data not loaded properly. Try refreshing the page.",
                timer: 7000
            })
        }
    }

    let updateModal = (
        <ConfirmationModal
            className={"com-activation__update-modal"}
            headerClassName={"update-modal__header"}
            description={"Confirm COM " + (isRejecting.current? "Rejection":"Activation")}
            bodyFooterClassName={"update-modal__inputs-wrapper"}
            input={(
                <>
                    {/* Inputs */}
                    {isBooleanFalseNotNullUndefined(isSingleUpdate)? (
                        selectedCOMs.map((details, idx) => {
                            let comId = details?.ComId;

                            return (
                                <div key={idx} className={"inputs-wrapper__inputs"}>
                                    <FormInput_textarea
                                        className={"inputs__reason flex-fill"}
                                        customInputClassName={"reason__input"}
                                        inputLabel={"COM ID: " + comId}
                                        inputPlaceholder={(isRejecting.current? "Rejection":"Activation") + " Reason Here"}

                                        inputValue={selectedCOMReasons?.[idx]}

                                        propagateValueChange={(stateName, value) => { 
                                            let newObj = cloneObject(selectedCOMReasons);
                                            newObj[idx] = value;
                                            setSelectedCOMReasons(newObj);
                                        }}
                                        isResetRequired={!isModalVisible}
                                        isMarginBtmOptional isInputOptional
                                    />
                                </div>
                            )
                        })
                    ):(
                        <FormInput_textarea
                            className={"inputs-wrapper__reason w-100"}
                            customInputClassName={"reason__input"}

                            inputPlaceholder={(isRejecting.current? "Rejection":"Activation") + " Reason Here"}
                            inputValue={selectedCOMReasons["0"]}

                            propagateValueChange={(stateName, value) => { 
                                setSingleCOMReason(value);
                            }}

                            isResetRequired={!isModalVisible}
                            isMarginBtmOptional isLabelOptional isInputOptional
                        />
                    )}
                </>
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={() => {
                if (isSingleUpdate) { 
                    updateSingleCOM();
                }
                else {
                    updateMultipleCOMs();
                }
            }}
            isActionLoading={isUpdatingMultiple}
            isConfirmSuccessful={isUpdateSuccessful}
        />
    );


    return {
        updateMultipleCOMs, updateSingleCOM,
        selectedCOMs, setSelectedCOMs,
        selectedCOMReasons, setSelectedCOMReasons,
        isUpdatingMultiple,

        isSingleUpdate, setIsSingleUpdate,
        singleCOMDetail, setSingleCOMDetail,
        singleCOMReason, setSingleCOMReason,

        updatingSingleRowPos,
        isUpdateSuccessful,
        isRejecting,

        updateModal, setIsModalVisible
    }
}